module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-300-latin-ext2.d035c4a.woff2";